const initialState={
  data:[],
  dataview:[],
};
const DFeedbackReducers=(state=initialState,action:any)=>{
  switch (action.type) {
      case 'FETCH_DATA_SUCCESS':
        return { ...state, data: action.payload };
        case 'FETCH_DATA_VIEW_SUCCESS':
          return { ...state, dataview: action.payload };  
      default:
        return state;
}
};
export default DFeedbackReducers;